import { useTranslation } from "react-i18next";
import "../videoshome.scss";
const VideoshomeHeader = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className={"add_div"}>

            <div>
           <span className={"profile_title_conf"}>{t('configuration.homePage.Videoshome')}</span>
           </div>
           
          </div>


            
        </div>
    )
}

export default VideoshomeHeader
